import React from 'react';
import { ImageProps } from '.';

const SvgZexpressEmblemBadge = ({ size = 65, ...props }: ImageProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={(size && Math.floor(size / 2.9545454545454546)) || 22}
      fill='none'
      viewBox='0 0 65 22'
      {...props}
    >
      <path
        fill='#fff'
        d='M0 4c0-2.21 1.848-4 4.127-4h56.746C63.153 0 65 1.79 65 4v14c0 2.21-1.848 4-4.127 4H4.127C1.847 22 0 20.21 0 18V4Z'
      />
      <path
        fill='#E2E5E6'
        d='M61 21v1H4v-1h57Zm3-3V4a3 3 0 0 0-2.846-2.996L61 1H4a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3v1l-.206-.005a4 4 0 0 1-3.79-3.789L0 18V4a4 4 0 0 1 4-4h57a4 4 0 0 1 4 4v14l-.005.206a4 4 0 0 1-3.789 3.79L61 22v-1a3 3 0 0 0 3-3Z'
      />
      <path
        fill='#6E52FF'
        d='M29.489 16.13h-1.433v-2.493h-5.572V12.48h7.005v3.65ZM49.139 16.13h-1.366v-5.202h-.917v4.726h-1.354V5.963h1.354v3.786h.917V5.815h1.366V16.13Z'
      />
      <path
        fill='#6E52FF'
        fillRule='evenodd'
        d='M54.616 12.458c2.215 0 3.536.669 3.547 1.848-.011 1.178-1.332 1.824-3.547 1.824-2.238 0-3.57-.646-3.57-1.824 0-1.18 1.332-1.848 3.57-1.848Zm0 1.1c-1.421 0-2.126.237-2.115.748-.011.51.694.748 2.115.748 1.387 0 2.103-.239 2.114-.748-.01-.51-.727-.749-2.114-.749Z'
        clipRule='evenodd'
      />
      <path
        fill='#6E52FF'
        d='M33.78 14.793h5.651v1.156h-7.094v-3.344h1.443v2.188ZM13.4 6.19c2.954-.048 5.35 1.842 5.35 4.643l-.007.259c-.144 2.657-2.482 4.429-5.344 4.382-.547-.009-.968-.076-1.563-.244-1.862-.526-5.528-2.77-6.774-3.705-.127-.095-.044-.286.116-.27l7.501.728c.115.012.181.129.126.225l-.723 1.253c-.08.139.088.286.228.202l4.363-2.639a.222.222 0 0 0 0-.383L12.31 8c-.14-.084-.307.064-.228.202l.723 1.254c.054.096-.011.212-.126.224l-7.501.729c-.16.015-.241-.175-.116-.27 1.246-.934 4.912-3.181 6.774-3.707.595-.167 1.016-.235 1.563-.243Z'
      />
      <path
        fill='#6E52FF'
        fillRule='evenodd'
        d='M41.944 9.057h1.387V6.734h1.32v6.948h-4.05V6.734h1.343v2.323Zm0 3.469h1.387V10.19h-1.387v2.335Z'
        clipRule='evenodd'
      />
      <path
        fill='#6E52FF'
        d='M39.163 13.285H37.73V5.827h1.433v7.458ZM36.656 7.708h-2.048v.148c0 1.235.75 2.494 2.428 3.004l-.727 1.133c-1.141-.363-1.947-1.105-2.406-2.04a4.124 4.124 0 0 1-2.484 2.233l-.738-1.134c1.69-.555 2.473-1.893 2.473-3.196v-.148H31.06V6.552h5.595v1.156ZM29.489 12.027h-1.433V5.815h1.433v6.212ZM55.32 10.735h3.95v1.156h-9.287v-1.156h3.928v-1.27h1.41v1.27ZM26.982 7.572h-2.048c.011 1.208.761 2.477 2.428 2.981l-.727 1.123c-1.141-.357-1.947-1.1-2.406-2.04a4.108 4.108 0 0 1-2.484 2.232l-.738-1.122c1.678-.55 2.461-1.887 2.473-3.174h-2.093V6.416h5.595v1.156Z'
      />
      <path
        fill='#6E52FF'
        d='M55.343 6.326c0 1.201 1.141 2.346 3.435 2.63l-.548 1.122c-1.717-.261-2.982-.992-3.626-2.03-.654 1.038-1.919 1.774-3.636 2.03l-.504-1.123c2.25-.283 3.424-1.462 3.424-2.63v-.34h1.455v.34Z'
      />
    </svg>
  );
};

export default SvgZexpressEmblemBadge;
